var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPermissionsEditTheirEvents(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3327 5.33333C10.3327 3.49239 8.84028 2 6.99935 2C5.1584 2 3.66602 3.49239 3.66602 5.33333C3.66602 7.17427 5.1584 8.66667 6.99935 8.66667C8.84028 8.66667 10.3327 7.17427 10.3327 5.33333Z",
    stroke: "#616161",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.33398 13.3327C2.33398 10.7553 4.42332 8.66602 7.00065 8.66602C7.85065 8.66602 8.64758 8.89328 9.33398 9.29035",
    stroke: "#616161",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4591 9.9566L13.0441 9.54153C12.7673 9.2648 12.3187 9.2648 12.0419 9.54153L9.8094 11.7741C9.51267 12.0708 9.3104 12.4488 9.22807 12.8603L9 14.0007L10.1403 13.7726C10.5519 13.6903 10.9299 13.488 11.2266 13.1913L13.4591 10.9587C13.7359 10.682 13.7359 10.2333 13.4591 9.9566Z",
    stroke: "#616161",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPermissionsEditTheirEvents);
export default __webpack_public_path__ + "static/media/permissions_edit_their_events.cc69bca88a9b08a88b997ab158fd8378.svg";
export { ForwardRef as ReactComponent };